<template>
  <div style="z-index: 10" class="dimed wrap" v-if="alertHomeYn || resetHomeYn" @mouseup="closeIfReset()">
    <div class="layer" v-if="alertHomeYn">
      <div class="layer__header">
        <div class="lyr-title">{{ $t('Modal.AlertHome.msg1') }}</div>
        <div class="ft-error">{{ $t('Modal.AlertHome.msg2') }}</div>
        <div class="lyr-txt">{{ $t('Modal.AlertHome.msg3') }}</div>
      </div>
      <div class="layer__body">
        <div class="info-area">
          <span class="img-error home"></span>
        </div>
      </div>
      <div class="layer__button">
        <button class="btn btn--cancel btn-anim" @mouseup="close()">{{ $t('Modal.AlertHome.msg4') }}</button>
        <button class="btn btn--error btn--shadow btn-anim" @mouseup="setHome">{{ $t('Modal.AlertHome.msg5') }}</button>
      </div>
      <!-- <div class="layer__button">
                        <button class="btn btn--line btn--xlg">かごに入れる</button>
                    </div> -->
    </div>
    <div class="layer" v-if="resetHomeYn">
      <div class="layer__header">
        <div class="lyr-title">{{ $t('Modal.AlertHome.msg6') }}</div>
        <div class="ft-error">{{ $t('Modal.AlertHome.msg7') }}</div>
      </div>
      <div class="layer__body">
        <div class="lyr-txt">{{ $t('Modal.AlertHome.msg8') }}</div>
        <div class="sub-txt" style="line-height: 10vh">
          <em class="reset">{{ num }}</em>
        </div>
      </div>
      <div class="layer__button">
        <button class="btn btn--line btn-anim btn--xlg" @mouseup="close()">{{ $t('Modal.AlertHome.msg9') }}</button>
      </div>
      <!-- <div class="layer__button">
                        <button class="btn btn--line btn--xlg">かごに入れる</button>
                    </div> -->
    </div>
  </div>
</template>
<script>
export default {
  name: 'alertHome',
  data() {
    return {
      darkModeYn: this.$store.getters.getDarkModeYn,
      resetHomeYn: this.$store.getters.getResetHomeYn,
      num: 5,
      timer: null,
      intval: null,
    };
  },
  mounted() {},
  updated() {
    this.$showButtonAnimation();
  },
  props: {
    alertHomeYn: Boolean,
  },
  methods: {
    close() {
      this.$store.dispatch('setResetHomeYn', false);
      clearTimeout(this.timer);
      clearInterval(this.intval);
      this.$emit('closeAlert');
    },
    closeIfReset() {
      if(this.resetHomeYn) {
        this.close();
      }
    },
    setHome() {
      this.$logInfo(`Reset Home`);
      this.$store.dispatch('setResetHomeYn', false);
      clearTimeout(this.timer);
      clearInterval(this.intval);
      this.$store.dispatch('setOrgBaskets', null);
      this.$emit('setHome');
    },
  },
  watch: {
    darkMode() {
      this.darkModeYn = this.darkModeYn ? false : true;
      this.$changeDarkMode(this.darkModeYn);
    },
    resetHome(val) {
      this.resetHomeYn = val;
      if (val) {
        this.num = 5;
        this.timer = setTimeout(() => {
          clearInterval(this.intval);
          this.$store.dispatch('setResetHomeYn', false);
          this.$router.replace('/user/idle');
        }, 5000);
        this.intval = setInterval(() => {
          this.num--;
        }, 1000);
      }
    },
  },
  computed: {
    resetHome: function () {
      return this.$store.getters.getResetHomeYn;
    },
  },
};
</script>

<style src="@/assets/css/user/common.css" scoped></style>
<style src="@/assets/css/user/dark/common-dark.css" scoped></style>
<style src="@/assets/css/user/pages/payment.css" scoped></style>
<style src="@/assets/css/user/dark/payment-dark.css" scoped></style>
<style scoped></style>
